export const DASH = "https://app.eth-bomb.com";
export const BOT_LINK = "https://app.eth-bomb.com";
export const INSTAGRAM = "https://";
// export const TELEGRAM = "https://t.me/TRXMoonBot";
